import * as jQuery from 'jquery';
var $ = jQuery;
export function imageLinkBlocksWidgetScripts() {
    $(document).ready(function () {
    });
}
